import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type SuspendedPageStore } from 'pages/suspended/store/suspendedPageStore'

export const SuspendedPageContext = createContext<SuspendedPageStore | null>(null)

export const useSuspendedPageContext = () => {
  const context = useContext(SuspendedPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with SuspendedPageContext')

  return context
}

type IProviderSuspendedPageProps = {
  value: SuspendedPageStore
  children: ReactNode
}

export const ProviderSuspendedPage: FC<IProviderSuspendedPageProps> = ({ value, children }) => {
  return <SuspendedPageContext.Provider value={value}>{children}</SuspendedPageContext.Provider>
}
